import { useBidFilterStore } from '../bids';
import { useDealsFilterStore } from '../deals';
import { useTransactionStore } from '../transactions';

/**
 * Returns a common hook that allows the user to clean up all the pending filters.
 */
export function useClearContentFiltersInStores() {
  const { clearTxnStore } = useTransactionStore();
  const { clearBidsStore } = useBidFilterStore();
  const { clearDealsStore } = useDealsFilterStore();

  const handleOnClearAllContentFilters = () => {
    clearBidsStore();
    clearDealsStore();
    clearTxnStore();
  };
  return { onClearAllContentFilters: handleOnClearAllContentFilters };
}
